import React, { useEffect, useState } from "react";
import { Hooks,Storage,Util,XtLocale,Context } from "@xt/xtbase";
const {useTranslation} = Hooks;
const { XtContext } = Context;
const {moment,getUrl,getOrigin} = Util;
import styles from "./index.module.less";
import {get_publicAdList,get_publicAdClickReport} from "@/api/xt-app";
import CloseIcon from '@/assets/images/ad/close';
import CheckonIcon from '@/assets/images/ad/checkon';
import CheckoffIcon from '@/assets/images/ad/checkoff';
const AppAd = () => {
  const [appState] = React.useContext(XtContext);
  const t = useTranslation();
  const [visible, setVisible] = useState(false);
  const [isNeverShow, setIsNeverShow] = useState(false);
  const [adDoc, setAdDoc] = useState(null);
  const parseData = (data)=>{
    if (!data || !data.length) return;
    let localDoc = {};
    const localAdList = Storage.get("adList");
    const today = moment().format("YYYY-MM-DD");
    if (localAdList && localAdList.day === today && localAdList.doc && typeof localAdList.doc === "object") {
      localDoc = localAdList.doc;
    }
    var doc = null;
    while(!doc && data.length)
    {
      doc = data.splice(parseInt(Math.random()*data.length),1)[0];
      if (doc.dailyDisplayTimes - (localDoc[doc.code] || 0) <= 0)
        doc = null;
    }
    if (doc) {
      localDoc[doc.code] = (localDoc[doc.code] || 0) + 1;
      Storage.set("adList", { day: today, doc: localDoc });
      setAdDoc(doc);
      const img = document.createElement("img");
      img.onload = ()=>{
        setVisible(true);
      }
      img.src = doc.imgUrl;
      return;
    }
  }
  useEffect(()=>{
    get_publicAdList().then((data)=>{
      parseData(data);
    })
  },[])
  const onClick = () => {
    if (!adDoc || !adDoc.clickLink) return;
    // const { code, clickLink } = adDoc;
    const clickLink = replaceUrlParameter(adDoc.clickLink);
    const { code } = adDoc;
    get_publicAdClickReport(code, { isAutoPopError: false });
    onClose();
    setTimeout(()=>{
      console.log(adDoc);
      const isHttp = /^(http:|https:)?\/\/.+/.test(clickLink);
      isHttp ? window.open(clickLink) : window.open(getUrl(clickLink));
    },0)

    function replaceUrlParameter(url) {
      const params = {
        __h5host__: typeof location === "undefined" ? "" : location.host.split(".").slice(-2).join("."),
        __pathLang__: XtLocale.getLangPath() || "en",
        __lang__: XtLocale.getLangCode() || "en",
        __currency__: appState.currency || "usd"
      };

      const reg = new RegExp(`(${Object.keys(params).join("|")})`, "g");
      return url.replace(reg, (attr) => params[attr]);
    }
  }
  const onClose = () => {
    if (!adDoc) return;
    if (isNeverShow) {
      const { code, dailyDisplayTimes } = adDoc;
      let localDoc = {};
      const localAdList = Storage.get("adList");
      const today = moment().format("YYYY-MM-DD");
      if (localAdList && localAdList.day === today && localAdList.doc && typeof localAdList.doc === "object") {
        localDoc = localAdList.doc;
      }
      localDoc[code] = dailyDisplayTimes;
      Storage.set("adList", { day: today, doc: localDoc });
    }
    setVisible(false);
  }
  return visible ? <div className={styles["app-ad"]}>
    {adDoc ? <div>
      <div>
        <img src={adDoc.imgUrl} onClick={onClick} style={{ cursor: adDoc.clickLink ? 'pointer' : 'auto' }} />
        <div>
          {isNeverShow ? <CheckonIcon onClick={()=>{setIsNeverShow(!isNeverShow)}}/> : <CheckoffIcon onClick={()=>{setIsNeverShow(!isNeverShow)}}/>}
          <span style={{"margin-left":"5px"}}>{ t("home.todayNeverShow") }</span>
        </div>
      </div>
      <button style={{"background":"transparent"}} onClick={onClose}>
        <CloseIcon/>
      </button>
    </div> : null}
  </div> : <></>;
}
export default AppAd;